<template>
  <div class="home flex-column">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('dashboard') }}</span>
      </div>
    </div>
    <div class="content flex-column">
      <button>{{ $t('add-time-period') }}</button>
      <div class="table-descriptors flex-row">
        <span>{{ $t('time-periods') }}</span>
        <div class="right">
          <input placeholder="$t('import-time-period')" />
          <button>IMPORT</button>
        </div>
      </div>
      <div class="table-container flex-column">
        <DataTable :headings="ccDashboardTH" :rows="tableRows" :perPage="numPerPage">
          <template v-slot:exportSlot="slotProps">
            <Eyecon class="eyecon" @click="exportForm(slotProps.row)"></Eyecon>
          </template>
          <template v-slot:viewSlot="slotProps">
            <Eyecon class="eyecon" @click="viewForm(slotProps.row)"></Eyecon>
          </template>
          <template v-slot:editSlot="slotProps">
            <Eyecon class="eyecon" @click="editForm(slotProps.row)"></Eyecon>
          </template>
          <template v-slot:copySlot="slotProps">
            <Copy class="copy-icon" @click="copyForm(slotProps.row)"></Copy>
          </template>
          <template v-slot:deleteSlot="slotProps">
            <Delete class="delete-icon" @click="openModal(slotProps.row)"></Delete>
          </template>
        </DataTable>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body">
        {{ $t('form-delete-warning') }}
        <div class="modal-button-container">
          <button class="submit" @click="deleteForm">{{ $t('submit') }}</button>
          <button @click="isModalOpen = false">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Modal from '@/components/Modal.vue';
import Eyecon from '@/assets/new/eye-con.svg';
import Copy from '@/assets/new/icon_copy.svg';
import Delete from '@/assets/new/icon_trash.svg';
import { mapState } from 'vuex';
import ccDashboardTH from '@/utils/tableHeaders/ccDashboardTH';

export default {
  name: 'CCDashboard',
  components: {
    DataTable,
    Modal,
    Eyecon,
    Copy,
    Delete,
  },
  data() {
    return {
      tableRows: [],
      numPerPage: 10,
      page: 1,
      rows: null,
      isModalOpen: false,
      ccDashboardTH: ccDashboardTH(),
    };
  },
  methods: {
    getPeriodData() {
      const loader = this.$loading.show();

      const domain = this.programName;

      this.$store.dispatch('getAllPeriods', { domain }).then((res) => {
        this.tableRows = res;
        loader.hide();
      });
    },
    exportForm() {
      return null;
    },
    viewForm() {
      return null;
    },
    editForm() {
      return null;
    },
    copyForm() {
      return null;
    },
    deleteForm() {
      return null;
    },
  },
  computed: {
    ...mapState('global', ['programName']),
  },
  created() {
    this.getPeriodData();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    display: flex;
  }
}
.content {
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  flex-wrap: wrap;
  margin-top: 50px;
  button {
    width: 200px;
  }
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}
.table-descriptors {
  justify-content: space-between;
  margin-top: 50px;
  font-size: 24px;
  align-items: center;
  .right {
    display: flex;
    input {
      margin-right: 20px;
    }
  }
}
.table-container {
  margin-top: 50px;
}
</style>
